import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

function trackEvent(
  category: Category,
  property: Property,
  action: Action,
  label?: string,
  value?: number
): void {
  trackStructuredEvent({
    category,
    property,
    action,
    label,
    value,
  });
}

export enum Category {
  BrowseMapResults = 'browse_map_results',
  BrowseHybridResults = 'browse_hybrid_results',
  BrowseMapCard = 'browse_map_card',
  BrowseHybridCard = 'browse_hybrid_map_card',
}

enum Property {
  ResultsOverview = 'results_overview',
  Map = 'map',
  MapPin = 'map_pin',
  HybridMapPin = 'hybrid_map_pin',
  MapSearch = 'map_search',
  Services = 'services',
  GoToVenue = 'go_to_venue',
}

enum Action {
  Loaded = 'loaded',
  Select = 'select',
  Zoom = 'zoom',
  Click = 'click',
  Pan = ' pan',
  Show = 'show',
  Hide = 'hide',
  Highlight = 'highlight',
}

export const trackLoadResults = (
  category: Category,
  venues: string,
  average: number
) =>
  trackEvent(
    category,
    Property.ResultsOverview,
    Action.Loaded,
    venues,
    average
  );

export const trackPanMap = (category: Category, zoomLevel: number) =>
  trackEvent(category, Property.Map, Action.Pan, '', zoomLevel);

export const trackSelectMapPin = (
  category: Category,
  id: string,
  rating: number
) => trackEvent(category, Property.MapPin, Action.Select, id, rating);

export const trackHighlightMapPin = (id: string, rating: number) =>
  trackEvent(
    Category.BrowseHybridCard,
    Property.HybridMapPin,
    Action.Highlight,
    id,
    rating
  );

export const trackGoToVenue = (category: Category, id: number) =>
  trackEvent(category, Property.GoToVenue, Action.Click, 'map_card', id);

export const trackZoomMap = (
  category: Category,
  direction: string,
  zoomLevel: number
) => trackEvent(category, Property.Map, Action.Zoom, direction, zoomLevel);

export const trackRedoSearch = (category: Category) =>
  trackEvent(category, Property.MapSearch, Action.Click);

export const trackShowServices = (
  category: Category,
  id: string,
  rating: number
) => trackEvent(category, Property.Services, Action.Show, id, rating);

export const trackHideServices = (
  category: Category,
  id: string,
  rating: number
) => trackEvent(category, Property.Services, Action.Hide, id, rating);
